import { Link, useLocation } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { ChevronDownIcon } from '@heroicons/react/24/outline'
import UserProfileMenu from './UserProfileMenu'
import dentsuLogo from '@/assets/dentsu-connect-logo.svg'
import { useSessionStore } from '@/contexts/SessionProvider'

const isUuid = (segment?: string) => Boolean(segment && segment.match(/^[a-f0-9-]{36}$/))

export default function TopNavigation() {
  const location = useLocation()
  const pathname = location.pathname
  const [currentProjectId, setCurrentProjectId] = useState<string | null>(null)

  // Extract project ID from URL
  useEffect(() => {
    const segments = pathname.split('/').filter(Boolean)
    let projectId: string | null = null
    if ((segments[0] === 'project' || segments[0] === 'projects') && isUuid(segments[1])) {
      projectId = segments[1]
    } else if (segments[0] === 'project' && isUuid(segments[2])) {
      projectId = segments[2]
    }

    setCurrentProjectId(projectId)
  }, [pathname])

  // Use sessionStore to get project data (cached)
  const { project } = useSessionStore(currentProjectId || undefined)
  const clientName = project?.client_name || project?.name || null

  return (
    <header className="fixed top-0 left-0 right-0 z-[70] bg-[#1a1a2e] border-b border-gray-800">
      <div className="relative h-[44px] px-5 flex items-center justify-between">
        {/* Left Section - Logo and Client */}
        <div className="flex items-center gap-3">
          <Link to="/" className="hover:opacity-80 transition-opacity">
            <img src={dentsuLogo} alt="Dentsu Connect" className="h-[11px] w-auto" />
          </Link>
          {currentProjectId && clientName && (
            <>
              <span className="text-white/70 text-xs">/</span>
              <Link
                to={`/project/${currentProjectId}`}
                className="flex items-center gap-2 hover:opacity-80 transition-opacity"
              >
                <div className="flex items-center gap-2">
                  <div className="w-5 h-5 rounded-full bg-blue-400 border border-blue-300 flex items-center justify-center">
                    <div className="w-3 h-3 bg-blue-200 rounded-sm" />
                  </div>
                  <span className="text-white text-xs font-medium leading-[22px]">
                    {clientName}
                  </span>
                  <ChevronDownIcon className="w-3 h-3 text-white" />
                </div>
              </Link>
            </>
          )}
        </div>

        {/* Right Section - User Menu */}
        <div className="flex items-center">
          <UserProfileMenu variant="dark" />
        </div>
      </div>
    </header>
  )
}
